import { CarouselBreakpoints } from '~/common/types/types';

const getBreakpoints = (breakpoints: CarouselBreakpoints): number[] => {
  return Object.keys(breakpoints).map((breakpoint) => {
    return Number(breakpoint);
  });
};

export { getBreakpoints };
